import { isPlatformServer } from '@angular/common';
import { Inject, Injectable, Optional, PLATFORM_ID, TransferState } from '@angular/core';
import { REQUEST_MARK_TOKEN } from '../tokens/request-mark.token';
import { DateTime } from 'luxon';
import { REQUEST, RESPONSE } from 'src/express.tokens';


/** 日誌，只有 console 打印 */
@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  protected isServer: boolean;
  protected isSSRMode: boolean;

  constructor(
    @Inject(PLATFORM_ID) protected platformId: object,
    protected transferState: TransferState,
    @Optional() @Inject(REQUEST_MARK_TOKEN) protected requestMark: string|null,
    @Optional() @Inject(REQUEST) protected request: Request,
    @Optional() @Inject(RESPONSE) protected response: Response,
  ) {
    this.isServer = isPlatformServer(this.platformId);
    this.isSSRMode = !!this.requestMark;
  }

  debug(msg: string, ...optionalParams: any[]) {
    if (this.isSSRMode) {
      if (this.isServer) {
        global['nodeLogger']['debug'](this.request, this.response, msg, ...optionalParams);
      } else {
        console.log(`${DateTime.now().setZone('Asia/Taipei').toFormat('yyyy-MM-dd HH:mm:ss.SSS')} [${'debug'}] ${msg}`, ...optionalParams);
      }
    } else {
      console.log(msg, ...optionalParams);
    }
  }

  info(msg: string, ...optionalParams: any[]) {
    if (this.isSSRMode) {
      if (this.isServer) {
        global['nodeLogger']['info'](this.request, this.response, msg, ...optionalParams);
      } else {
        console.log(`${DateTime.now().setZone('Asia/Taipei').toFormat('yyyy-MM-dd HH:mm:ss.SSS')} [${'info'}] ${msg}`, ...optionalParams);
      }
    } else {
      console.log(msg, ...optionalParams);
    }
  }

  warn(msg: string, ...optionalParams: any[]) {
    if (this.isSSRMode) {
      if (this.isServer) {
        global['nodeLogger']['error'](this.request, this.response, msg, ...optionalParams);
      } else {
        console.warn(`${DateTime.now().setZone('Asia/Taipei').toFormat('yyyy-MM-dd HH:mm:ss.SSS')} [${'error'}] ${msg}`, ...optionalParams);
      }
    } else {
      console.warn(msg, ...optionalParams);
    }
  }

  error(msg: string, ...optionalParams: any[]) {
    if (this.isSSRMode) {
      if (this.isServer) {
        global['nodeLogger']['error'](this.request, this.response, msg, ...optionalParams);
      } else {
        console.log(`${DateTime.now().setZone('Asia/Taipei').toFormat('yyyy-MM-dd HH:mm:ss.SSS')} [${'error'}] ${msg}`, ...optionalParams);
      }
    } else {
      console.error(msg, ...optionalParams);
    }
  }
}
